import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import BlockOutlinedSvg from "@ant-design/icons-svg/es/asn/BlockOutlined";
import AntdIcon from "../components/AntdIcon";
var BlockOutlined = function BlockOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BlockOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  BlockOutlined.displayName = 'BlockOutlined';
}
export default /*#__PURE__*/React.forwardRef(BlockOutlined);